import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ReactTable from '../react-table/table/ReactTable';
import ReactTableHead from '../react-table/table/ReactTableHead';
import ReactTableBody from '../react-table/table/ReactTableBody';
import ReactTableFooter from '../react-table/table/ReactTableFooter';
import TablePaginationActions from '../react-table/TablePaginationActions';

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    backgroundColor: '#0059a6',
    fontSize: '1rem',
    '& .MuiTableSortLabel-icon': {
      fill: 'white',
    },
    '& .MuiTableCell-head': {
      whiteSpace: 'nowrap',
    },
  },
  columnHeader: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  tableRow: {
    cursor: 'pointer',
    fontSize: '1rem',
  },
  tableCell: {
    fontSize: '1rem',
  },
  odd: {
    '& tr:nth-child(odd)': {
      backgroundColor: theme.palette.backdrop.main,
    },
  },
}));

const JobTable = ({
  tableColumns,
  tableHookProps,
  onOpen,
  columnClicksToIgnore,
}) => {
  const classes = useStyles();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    gotoPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableHookProps;

  const handleChangePage = (newPage) => {
    gotoPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onCellClick = (event, rowData, columnId) => {
    if (!columnClicksToIgnore.includes(columnId)) {
      onOpen(rowData);
    }
  };

  return (
    <>
      <ReactTable tableProps={getTableProps()}>
        <ReactTableHead headerGroups={headerGroups} classes={classes} />
        <ReactTableBody
          tableBodyProps={getTableBodyProps()}
          page={page}
          prepareRow={prepareRow}
          onCellClick={onCellClick}
          classes={classes}
        />
        <ReactTableFooter
          rows={rows}
          columns={tableColumns}
          pageSize={pageSize}
          pageIndex={pageIndex}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </ReactTable>
    </>
  );
};

JobTable.defaultProps = {
  columnClicksToIgnore: [],
};

JobTable.propTypes = {
  tableColumns: PropTypes.any.isRequired,
  tableHookProps: PropTypes.any.isRequired,
  onOpen: PropTypes.func.isRequired,
  columnClicksToIgnore: PropTypes.array,
};

export default JobTable;
